import { htmlNodes } from './htmlNodes';

export const generateImageTag = (chartRef: HTMLDivElement) => {
  const canvas = chartRef?.querySelector('canvas');

  if (canvas) {
    return htmlNodes.img(canvas.toDataURL('image/png', 1.0));
  }

  return '';
};
